import Connect from '../../services/connect';
import Config from '../../config';
import History from '../../util/history';
import Storage from '../../services/api/store';
import CONSTANT from '../../constant';
import { getNavigatorLang } from '../../locales';
import { parseRoute } from '../../util';

export const UPDATER_CHECKER = 'UPDATER_CHECKER';
export const SET_UPDATER_FIRMWARE_DATA = 'SET_UPDATER_FIRMWARE_DATA';
export const EXEC_DOWNLOAD_UPDATE = 'EXEC_DOWNLOAD_UPDATE';
export const UPDATER_FIRMWAREN = 'UPDATER_FIRMWAREN';
export const REMIND_UPDATE = 'REMIND_UPDATE';
export const IGNORE_UPDATE_VERSION = 'IGNORE_UPDATE_VERSION';

/**
 * 检查更新
 *
 * url: '检查更新请求的 url',
 * burl: '检查软件匹配的固件请求的 url'
 * version: 'mblock 的版本号',
 *
 * @author LiHuan
 */
const checkUpdate = () => {
    return new Promise((resolve, reject) => {
        const params = {
            url: Config.domain.mblock + 'mblock/isupdate',
            burl: Config.domain.mblock + 'mblock/firmware',
            version: Config.appVersion,
            lang: Storage.get(CONSTANT.INTL_LANG_KEY) || getNavigatorLang()
        };
        const checkTimer = setTimeout(() => {
            reject({ code: 10031 });
        }, 3000);
        Connect.updater('check_update', params, (err, data) => {
            clearTimeout(checkTimer);
            if (err) {
                return reject(err);
            }
            return resolve(data);
        });
    });
};

/**
 * 更新软件及固件
 *
 * url: '获取下载文件请求的 url',
 * version: 'mblock 的版本号'
 *
 * @author LiHuan
 */
const update = (progress) => {
    return new Promise((resolve, reject) => {
        Connect.updater('update', {
            url: Config.domain.mblock + 'mblock/isupdate',
            version: Config.appVersion
        }, (err, data) => {
            if (err) {
                return reject(err);
            }
            return resolve(data);
        }, progress);
    });
};

/**
 * 获取当前软件匹配的固件信息
 * 用来 连接的设备进行比较，如果不匹配的话，就升级固件
 * @author LiHuan
 */
const getFirmwareVersion = () => {
    return new Promise((resolve, reject) => {
        Connect.updater('version', {}, (err, data) => {
            if (err) {
                return reject(err);
            }
            return resolve(data);
        });
    });
};

const checker = (isAuto = false) => {
    const state = {
        type: UPDATER_CHECKER,
        payload: {
            isAuto,
            isChecking: true
        }
    };
    return async (dispatch, getState) => {
        dispatch(state);
        if (!isAuto && History.location.pathname !== parseRoute('/updater/app/checker')) {
            History.push(parseRoute('/updater/app/checker'));
        }
        try {
            const data = await checkUpdate();
            console.log({ checker: data });
            state.payload = {
                code: 0,
                model: {
                    ...data
                },
                isChecking: false
            };
            dispatch(state);
            // TODO: 自动检测
            if (isAuto) {
                const { updater } = getState();
                const { isRemind } = updater;
                if (isRemind && History.location.pathname !== parseRoute('/updater/app/checker')) {
                    History.push(parseRoute('/updater/app/checker'));
                }
            }
        } catch (err) {
            state.payload = {
                code: err.code,
                isChecking: false
            };
            dispatch(state);
        }
    };
};

let downloadTimer = null;
const download = (successCb, failedCb) => {
    clearTimeout(downloadTimer);
    const state = {
        type: EXEC_DOWNLOAD_UPDATE,
        payload: {
            status: CONSTANT.UPLOAD_STATUS.READY,
            percent: 0
        }
    };
    const clean = (dispatch, delayTime = 2000) => {
        downloadTimer = setTimeout(() => {
            state.payload = null;
            dispatch(state);
        }, delayTime);
    };
    const error = dispatch => {
        state.payload.status = CONSTANT.UPLOAD_STATUS.FAILED;
        failedCb && failedCb();
        dispatch(state);

        // 下载错误，10s 后消失
        clean(dispatch, 10000);
    };
    return async dispatch => {
        dispatch(state);
        try {
            await update((err, percent) => {
                if (err) {
                    return error(dispatch);
                }
                if (percent < 100) {
                    state.payload.status = CONSTANT.UPLOAD_STATUS.PROCESSING;
                } else {
                    state.payload.status = CONSTANT.UPLOAD_STATUS.DONE;
                    successCb && successCb();

                    // 进度完成，2s 后消失
                    clean(dispatch);
                }
                state.payload.percent = percent;
                dispatch(state);
            });
        } catch (err) {
            error(dispatch);
        }
    };
};

const remind = (isRemind = false) => {
    Storage.set(CONSTANT.REMIND_UPDATE, isRemind);
    return {
        type: REMIND_UPDATE,
        payload: isRemind
    };
};

const ignore = (version) => {
    let versions = Storage.get(CONSTANT.IGNORE_UPDATE_VERSIONS);
    if (versions === null) {
        versions = [];
    }
    if (versions.indexOf(version) === -1) {
        versions.push(version);
    }
    Storage.set(CONSTANT.IGNORE_UPDATE_VERSIONS, versions);
    return {
        type: IGNORE_UPDATE_VERSION,
        payload: versions
    };
};

const firmware = (data) => {
    return {
        type: UPDATER_FIRMWAREN,
        payload: data
    };
};

export default {
    checker,
    download,
    remind,
    ignore,
    firmware,
    getFirmwareVersion
};